import { safeFetchAPI, SafeFetchResponse } from '../index'
import { AnalyticsEventRequest, MenuType } from '../../types/widget'
import { API_BASE } from './index'

export async function recordAnalyticsEvent(
  payload: AnalyticsEventRequest,
  queryParams?: {
    globalId?: string
    menuType?: MenuType
  }
): Promise<SafeFetchResponse<string>> {
  return safeFetchAPI<string>(`${API_BASE}/widget/event`, {
    method: 'POST',
    payload,
    queryParams: queryParams as Record<string, string>,
  })
}
